import React, { FC } from 'react';

import { currencies } from 'data';
import { observer } from 'mobx-react-lite';
import { useGolfShopStore } from 'stores/hooks';

export const CurrencyInfo: FC = observer(() => {
  const { currency } = useGolfShopStore();
  const currencyObject = currencies.find((currencyItem) => currencyItem.code === currency) || currencies[0];

  return <span>{`${currencyObject.symbol} ${currencyObject.text}`}</span>;
});
